<template>
  <div class="home-recruit-tab content-main">
    <div class="content-main__centered">
      <h4 class="appMain--text mb-2">Recruit</h4>
      <p class="mb-4">
        Attract and recruit new team members to your organization.
      </p>

      <v-card class="pa-6 text-center">
        <v-icon size="48" color="grey lighten-1" class="mb-4">
          mdi-account-search-outline
        </v-icon>
        <h5 class="text-h6 mb-2">Recruitment Tools</h5>
        <p class="text-body-2 grey--text">
          Find and connect with potential candidates.
        </p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRecruitTab',
};
</script>
